/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_HubInputs */

const tr_landing_cockpit_hub = /** @type {(inputs: Landing_Cockpit_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel Kokpit`)
};

const en_landing_cockpit_hub = /** @type {(inputs: Landing_Cockpit_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel Cockpit`)
};

const de_landing_cockpit_hub = /** @type {(inputs: Landing_Cockpit_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel Cockpit`)
};

const ru_landing_cockpit_hub = /** @type {(inputs: Landing_Cockpit_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кокпит ShopPanel`)
};

/**
* | output |
* | --- |
* | "ShopPanel Cockpit" |
*
* @param {Landing_Cockpit_HubInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_hub = /** @type {((inputs?: Landing_Cockpit_HubInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_HubInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_hub(inputs)
	if (locale === "de") return de_landing_cockpit_hub(inputs)
	if (locale === "ru") return ru_landing_cockpit_hub(inputs)
	return tr_landing_cockpit_hub(inputs)
});